export const demandViewsQueryKeys = {
  all: () => ['/demand-views'] as const,
  lists: () => [...demandViewsQueryKeys.all(), 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...demandViewsQueryKeys.lists(), JSON.stringify(params)] as const,
  detail: (id: number) => ['/demand-views', id] as const,
  activityLogs: (id: number) => [...demandViewsQueryKeys.detail(id), 'activity-logs'] as const,
};
